import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/** Espera sin silueta conocida. Para tablas, formularios y fichas, mejor un skeleton (components/common/Skeletons). */
const Loading = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }} aria-busy="true" aria-label="loading">
    <CircularProgress size={28} />
  </Box>
);

export default Loading;
